import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { PaypalSuccess } from "./Success";
import { PaypalCancel } from "./Cancel";

export const PaypalCallback = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/success`}>
        <PaypalSuccess />
      </Route>
      <Route path={`${path}/cancel`}>
        <PaypalCancel />
      </Route>
    </Switch>
  );
};
